<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev">User Management</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">User Management</h2>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search-box.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}} User{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2 pr-4">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedUser" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':25 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <!-- <button ngbDropdownItem (click)="openModalRemoveReviewFlag(onlyUserIds)">Remove Flag</button> -->
                    <button *ngFor="let userrole of newmainUserRoleList" ngbDropdownItem
                        (click)="assignRoleToUserGroup(userrole.userRolePermissionId)">Mark
                        As {{userrole.userRoleName}}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-3">
        <div class="col-12"
            *ngFor="let review of newmainUserList | paginate: {itemsPerPage: pageSize, currentPage: pageNo, totalItems:totalCountList}; let i=index">
            <div class="bg-lighter userbox rounded d-flex column-gap-2 flex-column">
                <div class="d-flex column-gap-4 mb-0 align-items-center">
                    <div class="custom-control custom-checkbox flex-shrink-0 mt-0">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="review.isSelected"
                            name="list_name" [id]="review.empId + 'list_name'" value="{{review.empId}}"
                            (change)="isAllSelected()">
                        <label [for]="review.empId + 'list_name'" class="custom-control-label cursor-pointer"></label>
                    </div>
                    <div class="d-flex w-100 align-items-center column-gap-4">
                        <div class="user-p">
                            <img class="circle-image-pos" src="assets/images/add-admin.png" width="50px;">
                            <img class="verified_user" src="assets/images/company/verified_user.png" width="30px;">
                        </div>
                        <div class="d-flex w-100 align-items-center column-gap-4 flex-wrap">
                            <div class="reviewadmin d-flex align-items-center column-gap-3">
                                <p class="mb-0 font-weight-bold text-primary h5 mb-0 cursor-pointer">
                                    {{review.adminName}}</p>
                                <p *ngIf="review.userRoleName!=null"
                                    class="mb-0 font-weight-semibold small d-flex align-items-center column-gap-2">
                                    <span class="namelist">{{review.userRoleName}}</span>
                                </p>
                            </div>
                            <p class="mt-1 small d-flex align-items-center column-gap-2 w-100 mb-0">
                                {{review.adminEmailId}}
                            </p>
                        </div>
                        <!-- <p class="mb-0">{{review.adminEmailId}}</p> -->
                        <div ngbDropdown class="ml-auto">
                            <button (click)="checkUserRoleFromMailList(review.userRoleName)" type="button"
                                class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                                <svg-icon src="../../../assets/images/icons/more_dots.svg"
                                    [svgStyle]="{ 'height.px':25 }"></svg-icon>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="download_dropdown">
                                <div *ngIf="review.userRoleName!=null">
                                    <button ngbDropdownItem
                                        (click)="removeRoleFromUser(review.employeeRoleMappingId)">Remove
                                        {{review.userRoleName}}</button>
                                    <button *ngFor="let userrole of newmainUserRoleListFiltred" ngbDropdownItem
                                        (click)="assignRoleToUser(review.empId, userrole.userRolePermissionId)">Mark
                                        As {{userrole.userRoleName}}</button>
                                </div>
                                <div *ngIf="review.userRoleName==null">
                                    <button *ngFor="let userrole of newmainUserRoleList" ngbDropdownItem
                                        (click)="assignRoleToUser(review.empId, userrole.userRolePermissionId)">Mark
                                        As {{userrole.userRoleName}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="totalCountList > 10">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handlePageChange($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{pageNo}}/{{fetchPage(totalCountList)}}</div>
            </div>
        </div>
    </div>
</div>